import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** チェックボックスのID */
  id: string;
  /** チェックボックスの値 */
  value: string;
  /** チェック状態 */
  checked?: true | false;
  /** チェック状態を変更したときの処理 */
  onChange: (event: any) => void;
  /** チェックボックスの非活性フラグ */
  isDisabled?: true | false;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'input';

/**
 * チェックボックスコンポーネント
 */
export const Checkbox: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  className,
  isDisabled,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _type = type || 'checkbox';
  const _clsName = className || _type;
  let _isDisabled = false;
  if (isDisabled != null) {
    _isDisabled = isDisabled;
  }
  return (
    <Element
      type={_type}
      {...props}
      className={_clsName}
      disabled={_isDisabled}
    >
      {props.children}
    </Element>
  );
};
Checkbox.displayName = 'Checkbox';
